var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2534 2681 c-317 -207 -796 -666 -1139 -1093 -43 -54 -73 -84 -80 -79 -66 53 -521 361 -533 361 -23 0 -212 -190 -212 -214 0 -12 67 -113 148 -226 191 -264 402 -571 504 -732 44 -70 89 -130 100 -134 33 -10 62 21 138 147 241 406 576 902 819 1214 205 264 446 535 574 648 52 46 67 65 67 86 0 54 -21 61 -182 61 l-145 0 -59 -39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165 2386 c-216 -35 -414 -137 -569 -292 -135 -135 -232 -305 -278 -490 -32 -129 -32 -362 0 -486 49 -186 125 -327 247 -456 104 -110 187 -173 310 -232 332 -162 705 -139 1015 61 327 211 509 588 469 971 -11 108 -18 132 -49 148 -23 13 -65 -2 -74 -26 -4 -9 -1 -53 5 -97 56 -384 -153 -777 -506 -952 -145 -72 -222 -89 -410 -89 -146 0 -168 3 -248 27 -377 116 -629 419 -666 802 -33 339 125 666 413 856 230 152 502 189 788 108 43 -12 49 -11 68 6 27 25 26 70 -3 89 -74 49 -358 78 -512 52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.338784b5549ecf2bd671eae8ec8d6de3.svg";
export { ForwardRef as ReactComponent };